import { render } from "./CounterLayout.vue?vue&type=template&id=0554ec44&scoped=true"
import script from "./CounterLayout.vue?vue&type=script&lang=js"
export * from "./CounterLayout.vue?vue&type=script&lang=js"

import "./CounterLayout.vue?vue&type=style&index=0&id=0554ec44&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0554ec44"]])

export default __exports__